module.exports = __webpack_public_path__ + "static/phone-4f7d3de1ddff814d95f83ddbcbc04615.jpg";